(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nzc-bat-preparation"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-nzc-preparation-picker]').forEach(root => {
    if (root.dataset.prepReady) return;
    const select = root.querySelector('[data-service]');
    const native = root.querySelector('[data-prep-native]');
    const ui = root.querySelector('[data-prep-ui]');
    const current = root.querySelector('[data-prep-current]');
    if (!select || !native || !ui || !current) return;
    const options = [...select.options].filter(option => option.value && !option.disabled);
    const groups = {
      knocking: options.filter(option => option.dataset.serviceKind === 'knocking'),
      'toe-guard': options.filter(option => option.dataset.serviceKind === 'toe-guard'),
      combined: options.filter(option => option.dataset.serviceKind === 'combined')
    };
    const labels = { none: root.dataset.labelNone, knocking: root.dataset.labelKnocking, 'toe-guard': root.dataset.labelToe, combined: root.dataset.labelCombined };
    const currency = document.body.dataset.currency || 'NZD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', { style: 'currency', currency }).format(Number(cents) / 100);
    const duration = option => {
      const match = option.textContent.match(/(\d+\+?)\s*hours?/i);
      return match ? match[1] + ' ' + root.dataset.labelHours : option.textContent.split('·')[0].trim();
    };
    const fieldset = (title, className) => {
      const element = document.createElement('fieldset');
      element.className = className;
      const legend = document.createElement('legend');
      legend.textContent = title;
      element.append(legend);
      return element;
    };
    const choice = (name, value, title, subtitle, saving) => {
      const label = document.createElement('label');
      label.className = 'nzc-prep-choice';
      const input = document.createElement('input');
      input.type = 'radio'; input.name = name; input.value = value;
      const body = document.createElement('span');
      const heading = document.createElement('strong'); heading.textContent = title; body.append(heading);
      if (subtitle) { const detail = document.createElement('small'); detail.textContent = subtitle; body.append(detail); }
      if (saving) { const badge = document.createElement('small'); badge.className = 'nzc-prep-saving'; badge.textContent = root.dataset.labelSave; body.append(badge); }
      label.append(input, body);
      return { label, input };
    };
    const modes = fieldset(root.dataset.labelChoice, 'nzc-prep-modes');
    const modeGrid = document.createElement('div'); modeGrid.className = 'nzc-prep-mode-grid'; modes.append(modeGrid);
    const modeInputs = new Map();
    const panels = new Map();
    const durationInputs = new Map();
    const remembered = new Map();
    const commit = value => {
      const option = [...select.options].find(option => option.value === value && !option.disabled);
      if (!option) return;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    ['none', 'knocking', 'toe-guard', 'combined'].forEach(kind => {
      if (kind !== 'none' && !groups[kind].length) return;
      const group = groups[kind] || [];
      const from = group.length > 1 ? root.dataset.labelFrom + ' ' : '+';
      const subtitle = kind === 'none' ? '+' + money(0) : from + money(group[0].dataset.price);
      const item = choice('nzc_preparation_mode', kind, labels[kind], subtitle, kind === 'combined');
      item.input.addEventListener('change', () => commit(kind === 'none' ? '' : remembered.get(kind) || group[0].value));
      modeInputs.set(kind, item.input); modeGrid.append(item.label);
      if (group.length > 1) {
        const panel = fieldset(root.dataset.labelDuration, 'nzc-prep-durations');
        const grid = document.createElement('div'); grid.className = 'nzc-prep-duration-grid'; panel.append(grid);
        group.forEach(option => {
          const item = choice('nzc_preparation_duration_' + kind, option.value, duration(option), '+' + money(option.dataset.price), false);
          item.input.addEventListener('change', () => commit(option.value));
          durationInputs.set(option.value, item.input); grid.append(item.label);
        });
        const facing = document.createElement('p'); facing.className = 'caption'; facing.textContent = root.dataset.labelFacing; panel.append(facing);
        panels.set(kind, panel);
      }
    });
    ui.append(modes, ...panels.values());
    const sync = () => {
      const selected = [...select.options].find(option => option.value === select.value && !option.disabled) || select.options[0];
      const kind = selected.value ? selected.dataset.serviceKind : 'none';
      modeInputs.forEach((input, mode) => { input.checked = mode === kind; });
      panels.forEach((panel, mode) => { panel.hidden = mode !== kind; });
      durationInputs.forEach((input, value) => { input.checked = value === selected.value; });
      if (selected.value) remembered.set(kind, selected.value);
      current.replaceChildren();
      const label = document.createElement('span'); label.textContent = root.dataset.labelPrice;
      const price = document.createElement('strong'); price.textContent = '+' + money(selected.dataset.price || 0);
      current.append(label, price);
    };
    select.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    sync(); ui.hidden = false; current.hidden = false; native.hidden = true;
    select.tabIndex = -1;
    root.dataset.prepReady = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nzc-draft-assets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var thumbnail = event.target.closest('[data-nzc-thumb]');
    if (thumbnail) {
      var mainImage = document.querySelector('.nzc-gallery__main img');
      if (mainImage) {
        mainImage.src = thumbnail.getAttribute('data-nzc-src');
        mainImage.alt = thumbnail.getAttribute('data-nzc-alt') || mainImage.alt;
      }
    }
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-nzc-variant-select]')) return;
    var option = event.target.options[event.target.selectedIndex];
    var price = document.querySelector('[data-nzc-price]');
    var button = document.querySelector('[data-nzc-add]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) button.disabled = option.dataset.available !== 'true';
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nzc-kit-helmet-size"] && !Shopify.designMode) return;
  try {
    (() => {
    const panel = document.querySelector('[data-nzc-kit-helmet]');
    const form = panel?.closest('form');
    if (!form) return;
    const variantSelect = form.querySelector('[name="id"]');
    const sizeSelect = panel.querySelector('select');
    const modelInput = panel.querySelector('input[type="hidden"]');
    const measurement = panel.querySelector('[data-helmet-measurement]');
    const sync = () => {
      const active = Boolean(variantSelect.value) && (panel.dataset.helmetMode === 'included' || /with helmet/i.test(variantSelect.selectedOptions[0]?.textContent || ''));
      panel.hidden = !active;
      sizeSelect.disabled = !active;
      sizeSelect.required = active;
      modelInput.disabled = !active;
      if (measurement) {
        measurement.disabled = !active;
        measurement.required = active;
        if (!active) measurement.value = '';
      }
      if (!active) sizeSelect.value = '';
    };
    document.addEventListener('variant:change', sync);
    variantSelect.addEventListener('change', sync);
    sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
